























































































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { ADD_ITEM } from '@/modules/home/store/action-types'
import { Item } from 'vue-modules'
import HomeFormCheckBox from '@/modules/home/components/HomeFormCheckBox.vue'
import HomeFormImageDrop from '@/modules/home/components/HomeFormImageDrop.vue'
import smoothReflow, { Options } from 'vue-smooth-reflow'

const home = namespace('home')
@Component({
  components: { HomeFormImageDrop, HomeFormCheckBox },
  mixins: [smoothReflow]
})
export default class HomeForm extends Vue {
  /***************************
   *  Form submission feature
   **************************/
  @home.Action(ADD_ITEM) addItem!: (item: Item) => void

  currentId: number = 1
  item: Item = {
    id: 0,
    isDrink: false,
    title: '',
    flavor: '',
    price: '',
    description: '',
    image: ''
  }
  errors = {
    title: '',
    flavor: '',
    price: ''
  }
  submitted: boolean = false

  get _message(): string {
    return !this.submitted ? 'CADASTRAR' : 'ADICIONADO!'
  }

  submit(): void {
    if (!this.validateForm()) return

    // Save with unique id
    this.item.id = this.currentId++

    // Replace dot for comma
    this.item.price = this.item.price.replace('.', ',')

    this.addItem({ ...this.item })
    this.resetForm()

    // Show success message
    this.submitted = true
    setTimeout(() => {
      this.submitted = false
    }, 2000)
  }

  resetForm(): void {
    // Reset models
    this.item.isDrink = false
    this.item.title = ''
    this.item.flavor = ''
    this.item.price = ''
    this.item.description = ''
    this.item.image = ''

    // Reset errors
    this.errors.title = ''
    this.errors.flavor = ''
    this.errors.price = ''
  }

  validateForm(): boolean {
    // Trim white spaces
    this.item.title = this.item.title.trim()
    this.item.flavor = this.item.flavor.trim()
    this.item.description = this.item.description.trim()

    // Format price if filled
    if (this.item.price)
      this.item.price = parseFloat(this.item.price).toFixed(2)

    const req = 'Deve preencher este campo'
    const min = 'Mínimo 3 caracteres'
    const max = 'Máximo 60 caracteres'
    const invalid = 'Precio inválido!'

    // Title input validation
    if (!this.item.title.length) {
      this.errors.title = req
    } else if (this.item.title.length < 3) {
      this.errors.title = min
    } else if (this.item.title.length > 60) {
      this.errors.title = max
    }

    // Flavor input validation
    if (!this.item.flavor.length) {
      this.errors.flavor = req
    } else if (this.item.flavor.length < 3) {
      this.errors.flavor = min
    } else if (this.item.flavor.length > 60) {
      this.errors.flavor = max
    }

    // Price input validation
    if (!this.item.price) {
      this.errors.price = req
    } else if (parseInt(this.item.price) < 1) {
      this.errors.price = invalid
    }

    // Check for errors and scroll + focus on input if any
    if (Object.values(this.errors).find((value) => value.length > 0)) {
      const elementId = Object.keys(this.errors)[
        Object.values(this.errors).findIndex((value) => value.length > 0)
      ]
      const element: HTMLElement = this.$refs[elementId] as HTMLElement
      element.focus({ preventScroll: true })

      // Added check to solve test error
      if (element.scrollIntoView) element.scrollIntoView({ behavior: 'smooth' })
      return false
    }
    return true
  }
  /********************************
   *  End: Form submission feature
   *******************************/

  /*************************
   *  Drag and Drop feature
   *************************/
  handleImageChange(image: string) {
    this.item.image = image
  }

  handleInvalidImage() {
    alert('A extensão deve ser JPG ou PNG')
  }
  /******************************
   *  End: Drag and Drop feature
   *****************************/

  mounted() {
    // Height transition feature
    const options: Options = {
      el: '#wrapper',
      hideOverflow: false,
      transition: 'height .25s ease-out'
    }
    this.$smoothReflow!(options)
  }
}
